//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.0.0 (NJsonSchema v10.7.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseClient {
    public token : string = "";
    private abort? : AbortController;
    private readonly AUTH_HEADER = "Authorization";
    
    setAuthToken(token:string):void{
        this.token = token;
    }

    setAbortControl(control: AbortController):void{
        this.abort = control;
    }

    transformOptions(options: any): Promise<any> {
        options.headers[this.AUTH_HEADER] = `Bearer ${this.token}`;
        if(this.abort){
        options.signal = this.abort.signal;
        }
        return Promise.resolve(options);
    }
}

export interface IAttachmentClient {

    getSasToken(blobName: string | null, contentType: string | null | undefined, editMode: boolean | undefined): Promise<string>;

    create(noteId: number | undefined, fileName: string | null | undefined, isSignature: boolean | null | undefined, witnessName: string | null | undefined, timeStamp: Date | null | undefined, totalChunks: number | undefined, chunkIndex: number | undefined, attachmentId: string | null | undefined, file: FileParameter | null | undefined): Promise<string>;

    update(id: number | undefined, fileName: string | null | undefined): Promise<string>;

    getFile(attachmentGuid: string | undefined): Promise<FileResponse>;

    createV2(noteId: number | undefined, fileName: string | null | undefined, isSignature: boolean | null | undefined, witnessName: string | null | undefined, timeStamp: Date | null | undefined, attachmentId: string | null | undefined): Promise<string>;

    getPreviewFile(attachmentGuid: string | undefined, otp: string | null | undefined, reason: string | null | undefined): Promise<FileResponse>;

    getPreviewVideo(attachmentGuid: string | undefined, otp: string | null | undefined, reason: string | null | undefined): Promise<string>;

    getZipFile(filename: string | null): Promise<FileResponse>;
}

export class AttachmentClient extends BaseClient implements IAttachmentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSasToken(blobName: string | null, contentType: string | null | undefined, editMode: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Attachment/sastoken/{blobName}?";
        if (blobName === undefined || blobName === null)
            throw new Error("The parameter 'blobName' must be defined.");
        url_ = url_.replace("{blobName}", encodeURIComponent("" + blobName));
        if (contentType !== undefined && contentType !== null)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        if (editMode === null)
            throw new Error("The parameter 'editMode' cannot be null.");
        else if (editMode !== undefined)
            url_ += "editMode=" + encodeURIComponent("" + editMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSasToken(_response);
        });
    }

    protected processGetSasToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    create(noteId: number | undefined, fileName: string | null | undefined, isSignature: boolean | null | undefined, witnessName: string | null | undefined, timeStamp: Date | null | undefined, totalChunks: number | undefined, chunkIndex: number | undefined, attachmentId: string | null | undefined, file: FileParameter | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Attachment?";
        if (noteId === null)
            throw new Error("The parameter 'noteId' cannot be null.");
        else if (noteId !== undefined)
            url_ += "NoteId=" + encodeURIComponent("" + noteId) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (isSignature !== undefined && isSignature !== null)
            url_ += "IsSignature=" + encodeURIComponent("" + isSignature) + "&";
        if (witnessName !== undefined && witnessName !== null)
            url_ += "WitnessName=" + encodeURIComponent("" + witnessName) + "&";
        if (timeStamp !== undefined && timeStamp !== null)
            url_ += "TimeStamp=" + encodeURIComponent(timeStamp ? "" + timeStamp.toISOString() : "") + "&";
        if (totalChunks === null)
            throw new Error("The parameter 'totalChunks' cannot be null.");
        else if (totalChunks !== undefined)
            url_ += "totalChunks=" + encodeURIComponent("" + totalChunks) + "&";
        if (chunkIndex === null)
            throw new Error("The parameter 'chunkIndex' cannot be null.");
        else if (chunkIndex !== undefined)
            url_ += "chunkIndex=" + encodeURIComponent("" + chunkIndex) + "&";
        if (attachmentId !== undefined && attachmentId !== null)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    update(id: number | undefined, fileName: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Attachment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getFile(attachmentGuid: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Attachment?";
        if (attachmentGuid === null)
            throw new Error("The parameter 'attachmentGuid' cannot be null.");
        else if (attachmentGuid !== undefined)
            url_ += "attachmentGuid=" + encodeURIComponent("" + attachmentGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createV2(noteId: number | undefined, fileName: string | null | undefined, isSignature: boolean | null | undefined, witnessName: string | null | undefined, timeStamp: Date | null | undefined, attachmentId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Attachment/create?";
        if (noteId === null)
            throw new Error("The parameter 'noteId' cannot be null.");
        else if (noteId !== undefined)
            url_ += "NoteId=" + encodeURIComponent("" + noteId) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (isSignature !== undefined && isSignature !== null)
            url_ += "IsSignature=" + encodeURIComponent("" + isSignature) + "&";
        if (witnessName !== undefined && witnessName !== null)
            url_ += "WitnessName=" + encodeURIComponent("" + witnessName) + "&";
        if (timeStamp !== undefined && timeStamp !== null)
            url_ += "TimeStamp=" + encodeURIComponent(timeStamp ? "" + timeStamp.toISOString() : "") + "&";
        if (attachmentId !== undefined && attachmentId !== null)
            url_ += "AttachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateV2(_response);
        });
    }

    protected processCreateV2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getPreviewFile(attachmentGuid: string | undefined, otp: string | null | undefined, reason: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/preview?";
        if (attachmentGuid === null)
            throw new Error("The parameter 'attachmentGuid' cannot be null.");
        else if (attachmentGuid !== undefined)
            url_ += "attachmentGuid=" + encodeURIComponent("" + attachmentGuid) + "&";
        if (otp !== undefined && otp !== null)
            url_ += "otp=" + encodeURIComponent("" + otp) + "&";
        if (reason !== undefined && reason !== null)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPreviewFile(_response);
        });
    }

    protected processGetPreviewFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPreviewVideo(attachmentGuid: string | undefined, otp: string | null | undefined, reason: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Attachment/previewVideo?";
        if (attachmentGuid === null)
            throw new Error("The parameter 'attachmentGuid' cannot be null.");
        else if (attachmentGuid !== undefined)
            url_ += "attachmentGuid=" + encodeURIComponent("" + attachmentGuid) + "&";
        if (otp !== undefined && otp !== null)
            url_ += "otp=" + encodeURIComponent("" + otp) + "&";
        if (reason !== undefined && reason !== null)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPreviewVideo(_response);
        });
    }

    protected processGetPreviewVideo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getZipFile(filename: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Attachment/zip/{filename}";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetZipFile(_response);
        });
    }

    protected processGetZipFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IClassificationClient {

    getProtectiveMarkings(): Promise<ProtectiveMarkingsViewModel>;

    getInformationManagementMarkers(): Promise<InformationManagementMarkersViewModel>;
}

export class ClassificationClient extends BaseClient implements IClassificationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProtectiveMarkings(): Promise<ProtectiveMarkingsViewModel> {
        let url_ = this.baseUrl + "/api/Classification/protectiveMarkings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProtectiveMarkings(_response);
        });
    }

    protected processGetProtectiveMarkings(response: Response): Promise<ProtectiveMarkingsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProtectiveMarkingsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProtectiveMarkingsViewModel>(null as any);
    }

    getInformationManagementMarkers(): Promise<InformationManagementMarkersViewModel> {
        let url_ = this.baseUrl + "/api/Classification/informationManagementMarkers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInformationManagementMarkers(_response);
        });
    }

    protected processGetInformationManagementMarkers(response: Response): Promise<InformationManagementMarkersViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InformationManagementMarkersViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InformationManagementMarkersViewModel>(null as any);
    }
}

export interface IConfigurationClient {

    get(): Promise<MobileConfigViewModel>;

    getMapsKey(): Promise<string>;
}

export class ConfigurationClient extends BaseClient implements IConfigurationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<MobileConfigViewModel> {
        let url_ = this.baseUrl + "/api/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<MobileConfigViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MobileConfigViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MobileConfigViewModel>(null as any);
    }

    getMapsKey(): Promise<string> {
        let url_ = this.baseUrl + "/api/Configuration/MapsKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMapsKey(_response);
        });
    }

    protected processGetMapsKey(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IIntegrationClient {

    get(criteria: NoteSearchCriteria): Promise<ExportNotesViewModel>;
}

export class IntegrationClient extends BaseClient implements IIntegrationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(criteria: NoteSearchCriteria): Promise<ExportNotesViewModel> {
        let url_ = this.baseUrl + "/api/Integration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ExportNotesViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportNotesViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportNotesViewModel>(null as any);
    }
}

export interface ILocationClient {

    getAddress(latitude: number | undefined, longitude: number | undefined): Promise<string>;
}

export class LocationClient extends BaseClient implements ILocationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAddress(latitude: number | undefined, longitude: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Location?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAddress(_response);
        });
    }

    protected processGetAddress(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ILogClient {

    getNoteAudits(): Promise<NoteAuditViewModel>;

    getExportAudits(): Promise<ExportAuditViewModel>;

    getSearchAudits(): Promise<SearchAuditViewModel>;
}

export class LogClient extends BaseClient implements ILogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getNoteAudits(): Promise<NoteAuditViewModel> {
        let url_ = this.baseUrl + "/api/Log/note";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNoteAudits(_response);
        });
    }

    protected processGetNoteAudits(response: Response): Promise<NoteAuditViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteAuditViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteAuditViewModel>(null as any);
    }

    getExportAudits(): Promise<ExportAuditViewModel> {
        let url_ = this.baseUrl + "/api/Log/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExportAudits(_response);
        });
    }

    protected processGetExportAudits(response: Response): Promise<ExportAuditViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportAuditViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportAuditViewModel>(null as any);
    }

    getSearchAudits(): Promise<SearchAuditViewModel> {
        let url_ = this.baseUrl + "/api/Log/search";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSearchAudits(_response);
        });
    }

    protected processGetSearchAudits(response: Response): Promise<SearchAuditViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchAuditViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchAuditViewModel>(null as any);
    }
}

export interface INoteClient {

    create(command: CreateNoteCommand): Promise<number>;

    update(command: UpdateNoteCommand): Promise<number>;

    getSessionNotesByDate(date: string | null | undefined): Promise<SessionViewModel>;

    createWithValidation(command: CreateNoteCommand): Promise<UpsertNoteResultViewModel>;

    updateWithValidation(command: UpdateNoteCommand): Promise<UpsertNoteResultViewModel>;

    createNoteWithHistory(command: CreateNoteWithHistoryCommand): Promise<UpsertNoteResultViewModel>;

    updateNoteWithHistory(command: UpdateNoteWithHistoryCommand): Promise<UpsertNoteResultViewModel>;

    getMonthlyNotes(date: Date | undefined): Promise<{ [key: string]: number; }>;

    getNotesHistory(): Promise<UserNotesHistoryViewModel>;

    getSessionNotes(date: Date): Promise<SessionViewModel>;

    search(password: string | null | undefined, searchFilter: SearchFilter): Promise<SearchNotesViewModel>;

    searchCount(password: string | null | undefined, searchFilter: SearchFilter): Promise<number>;

    export(password: string | null | undefined, exportPurpose: string | null | undefined, forSearch: boolean | undefined, searchFilter: SearchFilter): Promise<string>;

    media(password: string | null | undefined, exportPurpose: string | null | undefined, searchFilter: SearchFilter): Promise<string>;
}

export class NoteClient extends BaseClient implements INoteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(command: CreateNoteCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(command: UpdateNoteCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSessionNotesByDate(date: string | null | undefined): Promise<SessionViewModel> {
        let url_ = this.baseUrl + "/api/Note?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSessionNotesByDate(_response);
        });
    }

    protected processGetSessionNotesByDate(response: Response): Promise<SessionViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionViewModel>(null as any);
    }

    createWithValidation(command: CreateNoteCommand): Promise<UpsertNoteResultViewModel> {
        let url_ = this.baseUrl + "/api/Note/WithValidation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateWithValidation(_response);
        });
    }

    protected processCreateWithValidation(response: Response): Promise<UpsertNoteResultViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertNoteResultViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpsertNoteResultViewModel>(null as any);
    }

    updateWithValidation(command: UpdateNoteCommand): Promise<UpsertNoteResultViewModel> {
        let url_ = this.baseUrl + "/api/Note/WithValidation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWithValidation(_response);
        });
    }

    protected processUpdateWithValidation(response: Response): Promise<UpsertNoteResultViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertNoteResultViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpsertNoteResultViewModel>(null as any);
    }

    createNoteWithHistory(command: CreateNoteWithHistoryCommand): Promise<UpsertNoteResultViewModel> {
        let url_ = this.baseUrl + "/api/Note/WithHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNoteWithHistory(_response);
        });
    }

    protected processCreateNoteWithHistory(response: Response): Promise<UpsertNoteResultViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertNoteResultViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpsertNoteResultViewModel>(null as any);
    }

    updateNoteWithHistory(command: UpdateNoteWithHistoryCommand): Promise<UpsertNoteResultViewModel> {
        let url_ = this.baseUrl + "/api/Note/WithHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNoteWithHistory(_response);
        });
    }

    protected processUpdateNoteWithHistory(response: Response): Promise<UpsertNoteResultViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertNoteResultViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpsertNoteResultViewModel>(null as any);
    }

    getMonthlyNotes(date: Date | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/Note/month?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMonthlyNotes(_response);
        });
    }

    protected processGetMonthlyNotes(response: Response): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    getNotesHistory(): Promise<UserNotesHistoryViewModel> {
        let url_ = this.baseUrl + "/api/Note/noteshistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotesHistory(_response);
        });
    }

    protected processGetNotesHistory(response: Response): Promise<UserNotesHistoryViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotesHistoryViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserNotesHistoryViewModel>(null as any);
    }

    getSessionNotes(date: Date): Promise<SessionViewModel> {
        let url_ = this.baseUrl + "/api/Note/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSessionNotes(_response);
        });
    }

    protected processGetSessionNotes(response: Response): Promise<SessionViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionViewModel>(null as any);
    }

    search(password: string | null | undefined, searchFilter: SearchFilter): Promise<SearchNotesViewModel> {
        let url_ = this.baseUrl + "/api/Note/search?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchFilter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SearchNotesViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchNotesViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchNotesViewModel>(null as any);
    }

    searchCount(password: string | null | undefined, searchFilter: SearchFilter): Promise<number> {
        let url_ = this.baseUrl + "/api/Note/searchcount?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchFilter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCount(_response);
        });
    }

    protected processSearchCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    export(password: string | null | undefined, exportPurpose: string | null | undefined, forSearch: boolean | undefined, searchFilter: SearchFilter): Promise<string> {
        let url_ = this.baseUrl + "/api/Note/export?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (exportPurpose !== undefined && exportPurpose !== null)
            url_ += "exportPurpose=" + encodeURIComponent("" + exportPurpose) + "&";
        if (forSearch === null)
            throw new Error("The parameter 'forSearch' cannot be null.");
        else if (forSearch !== undefined)
            url_ += "forSearch=" + encodeURIComponent("" + forSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchFilter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    media(password: string | null | undefined, exportPurpose: string | null | undefined, searchFilter: SearchFilter): Promise<string> {
        let url_ = this.baseUrl + "/api/Note/media?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (exportPurpose !== undefined && exportPurpose !== null)
            url_ += "exportPurpose=" + encodeURIComponent("" + exportPurpose) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchFilter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMedia(_response);
        });
    }

    protected processMedia(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IOTPClient {

    create(number: string | null | undefined): Promise<boolean>;

    otpViaEmail(email: string | null | undefined): Promise<boolean>;

    resendOTPViaEmail(): Promise<boolean>;
}

export class OTPClient extends BaseClient implements IOTPClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(number: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/OTP?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    otpViaEmail(email: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/OTP/email?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOtpViaEmail(_response);
        });
    }

    protected processOtpViaEmail(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    resendOTPViaEmail(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/OTP/resendEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendOTPViaEmail(_response);
        });
    }

    protected processResendOTPViaEmail(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ITranscriptionsClient {

    createTranscription(command: CreateTranscriptionCommand): Promise<FileResponse>;

    getTranscription(attachmentGuid: string | undefined): Promise<TranscriptDto>;

    transcriptionFailed(command: TranscriptionFailedCommand): Promise<FileResponse>;

    updateTranscription(command: UpdateTranscriptionCommand): Promise<TranscriptDto>;

    deleteMalwareAttachment(attachmentId: string | null | undefined): Promise<string>;
}

export class TranscriptionsClient extends BaseClient implements ITranscriptionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createTranscription(command: CreateTranscriptionCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Transcriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTranscription(_response);
        });
    }

    protected processCreateTranscription(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTranscription(attachmentGuid: string | undefined): Promise<TranscriptDto> {
        let url_ = this.baseUrl + "/api/Transcriptions?";
        if (attachmentGuid === null)
            throw new Error("The parameter 'attachmentGuid' cannot be null.");
        else if (attachmentGuid !== undefined)
            url_ += "attachmentGuid=" + encodeURIComponent("" + attachmentGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTranscription(_response);
        });
    }

    protected processGetTranscription(response: Response): Promise<TranscriptDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TranscriptDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranscriptDto>(null as any);
    }

    transcriptionFailed(command: TranscriptionFailedCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Transcriptions/failed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTranscriptionFailed(_response);
        });
    }

    protected processTranscriptionFailed(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateTranscription(command: UpdateTranscriptionCommand): Promise<TranscriptDto> {
        let url_ = this.baseUrl + "/api/Transcriptions/editTranscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTranscription(_response);
        });
    }

    protected processUpdateTranscription(response: Response): Promise<TranscriptDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TranscriptDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranscriptDto>(null as any);
    }

    deleteMalwareAttachment(attachmentId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Transcriptions/delete?";
        if (attachmentId !== undefined && attachmentId !== null)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMalwareAttachment(_response);
        });
    }

    protected processDeleteMalwareAttachment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IUserClient {

    create(command: CreateUserCommand): Promise<string>;

    update(command: UpdateUserCommand): Promise<string>;

    getUser(): Promise<UserViewModel>;

    getLogs(id: string | null): Promise<UserAuditLogViewModel>;

    getUsers(): Promise<UsersViewModel>;

    usersSearch(query: string | null | undefined): Promise<SearchUserQueryModel>;

    getWorkUnits(): Promise<string[]>;

    searchUser(email: string | null | undefined): Promise<UserViewModel>;
}

export class UserClient extends BaseClient implements IUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(command: CreateUserCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    update(command: UpdateUserCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getUser(): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    getLogs(id: string | null): Promise<UserAuditLogViewModel> {
        let url_ = this.baseUrl + "/api/User/getlog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLogs(_response);
        });
    }

    protected processGetLogs(response: Response): Promise<UserAuditLogViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAuditLogViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAuditLogViewModel>(null as any);
    }

    getUsers(): Promise<UsersViewModel> {
        let url_ = this.baseUrl + "/api/User/getall";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<UsersViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsersViewModel>(null as any);
    }

    usersSearch(query: string | null | undefined): Promise<SearchUserQueryModel> {
        let url_ = this.baseUrl + "/api/User/usersearch?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUsersSearch(_response);
        });
    }

    protected processUsersSearch(response: Response): Promise<SearchUserQueryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchUserQueryModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchUserQueryModel>(null as any);
    }

    getWorkUnits(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/User/workunits";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkUnits(_response);
        });
    }

    protected processGetWorkUnits(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    searchUser(email: string | null | undefined): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/User/search?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchUser(_response);
        });
    }

    protected processSearchUser(response: Response): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserViewModel>(null as any);
    }
}

export class ProtectiveMarkingsViewModel implements IProtectiveMarkingsViewModel {
    protectiveMarkings?: ProtectiveMarkingDTO[] | undefined;

    constructor(data?: IProtectiveMarkingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["protectiveMarkings"])) {
                this.protectiveMarkings = [] as any;
                for (let item of _data["protectiveMarkings"])
                    this.protectiveMarkings!.push(ProtectiveMarkingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProtectiveMarkingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProtectiveMarkingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.protectiveMarkings)) {
            data["protectiveMarkings"] = [];
            for (let item of this.protectiveMarkings)
                data["protectiveMarkings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProtectiveMarkingsViewModel {
    protectiveMarkings?: ProtectiveMarkingDTO[] | undefined;
}

export class ProtectiveMarkingDTO implements IProtectiveMarkingDTO {
    id?: number;
    name?: string | undefined;
    sort?: number;
    isRedacted?: boolean;
    isIMMRequired?: boolean;
    colour?: string | undefined;
    isDefault?: boolean;

    constructor(data?: IProtectiveMarkingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sort = _data["sort"];
            this.isRedacted = _data["isRedacted"];
            this.isIMMRequired = _data["isIMMRequired"];
            this.colour = _data["colour"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): ProtectiveMarkingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProtectiveMarkingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sort"] = this.sort;
        data["isRedacted"] = this.isRedacted;
        data["isIMMRequired"] = this.isIMMRequired;
        data["colour"] = this.colour;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IProtectiveMarkingDTO {
    id?: number;
    name?: string | undefined;
    sort?: number;
    isRedacted?: boolean;
    isIMMRequired?: boolean;
    colour?: string | undefined;
    isDefault?: boolean;
}

export class InformationManagementMarkersViewModel implements IInformationManagementMarkersViewModel {
    informationManagementMarkers?: InformationManagementMarkerDTO[] | undefined;

    constructor(data?: IInformationManagementMarkersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["informationManagementMarkers"])) {
                this.informationManagementMarkers = [] as any;
                for (let item of _data["informationManagementMarkers"])
                    this.informationManagementMarkers!.push(InformationManagementMarkerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InformationManagementMarkersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InformationManagementMarkersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.informationManagementMarkers)) {
            data["informationManagementMarkers"] = [];
            for (let item of this.informationManagementMarkers)
                data["informationManagementMarkers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInformationManagementMarkersViewModel {
    informationManagementMarkers?: InformationManagementMarkerDTO[] | undefined;
}

export class InformationManagementMarkerDTO implements IInformationManagementMarkerDTO {
    id?: number;
    name?: string | undefined;
    sort?: number;

    constructor(data?: IInformationManagementMarkerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): InformationManagementMarkerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InformationManagementMarkerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sort"] = this.sort;
        return data;
    }
}

export interface IInformationManagementMarkerDTO {
    id?: number;
    name?: string | undefined;
    sort?: number;
}

export class MobileConfigViewModel implements IMobileConfigViewModel {
    tenantName?: string | undefined;
    tenantId?: string | undefined;
    signInPolicy?: string | undefined;
    passwordResetPolicy?: string | undefined;
    appId?: string | undefined;
    scope?: string | undefined;
    mapsSubscriptionKey?: string | undefined;
    mapsUIKey?: string | undefined;
    mapsCountryCode?: string | undefined;
    apiUri?: string | undefined;
    callbackPath?: string | undefined;
    idp?: string | undefined;
    authority?: string | undefined;
    mapsProvider?: string | undefined;
    appInsightKey?: string | undefined;
    version?: string | undefined;

    constructor(data?: IMobileConfigViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.tenantId = _data["tenantId"];
            this.signInPolicy = _data["signInPolicy"];
            this.passwordResetPolicy = _data["passwordResetPolicy"];
            this.appId = _data["appId"];
            this.scope = _data["scope"];
            this.mapsSubscriptionKey = _data["mapsSubscriptionKey"];
            this.mapsUIKey = _data["mapsUIKey"];
            this.mapsCountryCode = _data["mapsCountryCode"];
            this.apiUri = _data["apiUri"];
            this.callbackPath = _data["callbackPath"];
            this.idp = _data["idp"];
            this.authority = _data["authority"];
            this.mapsProvider = _data["mapsProvider"];
            this.appInsightKey = _data["appInsightKey"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): MobileConfigViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MobileConfigViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["tenantId"] = this.tenantId;
        data["signInPolicy"] = this.signInPolicy;
        data["passwordResetPolicy"] = this.passwordResetPolicy;
        data["appId"] = this.appId;
        data["scope"] = this.scope;
        data["mapsSubscriptionKey"] = this.mapsSubscriptionKey;
        data["mapsUIKey"] = this.mapsUIKey;
        data["mapsCountryCode"] = this.mapsCountryCode;
        data["apiUri"] = this.apiUri;
        data["callbackPath"] = this.callbackPath;
        data["idp"] = this.idp;
        data["authority"] = this.authority;
        data["mapsProvider"] = this.mapsProvider;
        data["appInsightKey"] = this.appInsightKey;
        data["version"] = this.version;
        return data;
    }
}

export interface IMobileConfigViewModel {
    tenantName?: string | undefined;
    tenantId?: string | undefined;
    signInPolicy?: string | undefined;
    passwordResetPolicy?: string | undefined;
    appId?: string | undefined;
    scope?: string | undefined;
    mapsSubscriptionKey?: string | undefined;
    mapsUIKey?: string | undefined;
    mapsCountryCode?: string | undefined;
    apiUri?: string | undefined;
    callbackPath?: string | undefined;
    idp?: string | undefined;
    authority?: string | undefined;
    mapsProvider?: string | undefined;
    appInsightKey?: string | undefined;
    version?: string | undefined;
}

export class ExportNotesViewModel implements IExportNotesViewModel {
    exportId?: string | undefined;
    exportedBy?: string | undefined;
    exportedByOrgId?: string | undefined;
    exportedByAccessControlGroup?: string | undefined;
    exportedDate?: string | undefined;
    exportPurpose?: string | undefined;
    exportTimeZone?: string | undefined;
    exportedDiaryDates?: string | undefined;
    relevantIds?: number[] | undefined;
    owners?: OwnerDTO[] | undefined;
    searchStartDate?: string | undefined;
    searchEndDate?: string | undefined;
    queryTerm?: string | undefined;
    tags?: Tag[] | undefined;
    searchedUser?: string | undefined;
    searchedAddress?: string | undefined;
    globalSearch?: boolean;
    resultCount?: number;
    authenticityVerified?: boolean;
    exportTypes?: ExportType[] | undefined;
    hostURL?: string | undefined;

    constructor(data?: IExportNotesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exportId = _data["exportId"];
            this.exportedBy = _data["exportedBy"];
            this.exportedByOrgId = _data["exportedByOrgId"];
            this.exportedByAccessControlGroup = _data["exportedByAccessControlGroup"];
            this.exportedDate = _data["exportedDate"];
            this.exportPurpose = _data["exportPurpose"];
            this.exportTimeZone = _data["exportTimeZone"];
            this.exportedDiaryDates = _data["exportedDiaryDates"];
            if (Array.isArray(_data["relevantIds"])) {
                this.relevantIds = [] as any;
                for (let item of _data["relevantIds"])
                    this.relevantIds!.push(item);
            }
            if (Array.isArray(_data["owners"])) {
                this.owners = [] as any;
                for (let item of _data["owners"])
                    this.owners!.push(OwnerDTO.fromJS(item));
            }
            this.searchStartDate = _data["searchStartDate"];
            this.searchEndDate = _data["searchEndDate"];
            this.queryTerm = _data["queryTerm"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag.fromJS(item));
            }
            this.searchedUser = _data["searchedUser"];
            this.searchedAddress = _data["searchedAddress"];
            this.globalSearch = _data["globalSearch"];
            this.resultCount = _data["resultCount"];
            this.authenticityVerified = _data["authenticityVerified"];
            if (Array.isArray(_data["exportTypes"])) {
                this.exportTypes = [] as any;
                for (let item of _data["exportTypes"])
                    this.exportTypes!.push(item);
            }
            this.hostURL = _data["hostURL"];
        }
    }

    static fromJS(data: any): ExportNotesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportNotesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportId"] = this.exportId;
        data["exportedBy"] = this.exportedBy;
        data["exportedByOrgId"] = this.exportedByOrgId;
        data["exportedByAccessControlGroup"] = this.exportedByAccessControlGroup;
        data["exportedDate"] = this.exportedDate;
        data["exportPurpose"] = this.exportPurpose;
        data["exportTimeZone"] = this.exportTimeZone;
        data["exportedDiaryDates"] = this.exportedDiaryDates;
        if (Array.isArray(this.relevantIds)) {
            data["relevantIds"] = [];
            for (let item of this.relevantIds)
                data["relevantIds"].push(item);
        }
        if (Array.isArray(this.owners)) {
            data["owners"] = [];
            for (let item of this.owners)
                data["owners"].push(item.toJSON());
        }
        data["searchStartDate"] = this.searchStartDate;
        data["searchEndDate"] = this.searchEndDate;
        data["queryTerm"] = this.queryTerm;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["searchedUser"] = this.searchedUser;
        data["searchedAddress"] = this.searchedAddress;
        data["globalSearch"] = this.globalSearch;
        data["resultCount"] = this.resultCount;
        data["authenticityVerified"] = this.authenticityVerified;
        if (Array.isArray(this.exportTypes)) {
            data["exportTypes"] = [];
            for (let item of this.exportTypes)
                data["exportTypes"].push(item);
        }
        data["hostURL"] = this.hostURL;
        return data;
    }
}

export interface IExportNotesViewModel {
    exportId?: string | undefined;
    exportedBy?: string | undefined;
    exportedByOrgId?: string | undefined;
    exportedByAccessControlGroup?: string | undefined;
    exportedDate?: string | undefined;
    exportPurpose?: string | undefined;
    exportTimeZone?: string | undefined;
    exportedDiaryDates?: string | undefined;
    relevantIds?: number[] | undefined;
    owners?: OwnerDTO[] | undefined;
    searchStartDate?: string | undefined;
    searchEndDate?: string | undefined;
    queryTerm?: string | undefined;
    tags?: Tag[] | undefined;
    searchedUser?: string | undefined;
    searchedAddress?: string | undefined;
    globalSearch?: boolean;
    resultCount?: number;
    authenticityVerified?: boolean;
    exportTypes?: ExportType[] | undefined;
    hostURL?: string | undefined;
}

export class OwnerDTO implements IOwnerDTO {
    sessions?: SessionDTO[] | undefined;
    name?: string | undefined;
    createdBy?: string | undefined;
    timezone?: string | undefined;
    position?: string | undefined;
    organisationId?: string | undefined;
    agency?: string | undefined;
    workGroup?: string | undefined;
    accessControlGroup?: AccessControlGroup;

    constructor(data?: IOwnerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(SessionDTO.fromJS(item));
            }
            this.name = _data["name"];
            this.createdBy = _data["createdBy"];
            this.timezone = _data["timezone"];
            this.position = _data["position"];
            this.organisationId = _data["organisationId"];
            this.agency = _data["agency"];
            this.workGroup = _data["workGroup"];
            this.accessControlGroup = _data["accessControlGroup"];
        }
    }

    static fromJS(data: any): OwnerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["createdBy"] = this.createdBy;
        data["timezone"] = this.timezone;
        data["position"] = this.position;
        data["organisationId"] = this.organisationId;
        data["agency"] = this.agency;
        data["workGroup"] = this.workGroup;
        data["accessControlGroup"] = this.accessControlGroup;
        return data;
    }
}

export interface IOwnerDTO {
    sessions?: SessionDTO[] | undefined;
    name?: string | undefined;
    createdBy?: string | undefined;
    timezone?: string | undefined;
    position?: string | undefined;
    organisationId?: string | undefined;
    agency?: string | undefined;
    workGroup?: string | undefined;
    accessControlGroup?: AccessControlGroup;
}

export class SessionDTO implements ISessionDTO {
    sessionDate?: string | undefined;
    ownerName?: string | undefined;
    sessionDateTime?: Date;
    notes?: NoteExportDTO[] | undefined;

    constructor(data?: ISessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionDate = _data["sessionDate"];
            this.ownerName = _data["ownerName"];
            this.sessionDateTime = _data["sessionDateTime"] ? new Date(_data["sessionDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteExportDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionDate"] = this.sessionDate;
        data["ownerName"] = this.ownerName;
        data["sessionDateTime"] = this.sessionDateTime ? this.sessionDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISessionDTO {
    sessionDate?: string | undefined;
    ownerName?: string | undefined;
    sessionDateTime?: Date;
    notes?: NoteExportDTO[] | undefined;
}

export class NoteExportDTO implements INoteExportDTO {
    id?: number;
    title?: string | undefined;
    sessionId?: number;
    deviceLatitude?: number;
    deviceLongitude?: number;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    type?: string | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    keywords?: string[] | undefined;
    attachments?: AttachmentDTO[] | undefined;
    createdBy?: string | undefined;
    ownerName?: string | undefined;
    ownerPosition?: string | undefined;
    ownerOrganisationId?: string | undefined;
    ownerAgency?: string | undefined;
    ownerGroup?: string | undefined;
    ownerEmail?: string | undefined;
    ownerTimezone?: string | undefined;
    ownerAccessControlGroup?: AccessControlGroup;
    created?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedByName?: string | undefined;
    lastModified?: Date | undefined;
    clientCreatedTime?: Date | undefined;
    clientUpdatedTime?: Date | undefined;
    deviceLocation?: string | undefined;
    declaredStartTime?: string | undefined;
    protectiveMarking?: ProtectiveMarking | undefined;
    protectiveMarkingName?: string | undefined;
    informationManagementMarker?: InformationManagementMarker | undefined;
    informationManagementMarkerName?: string | undefined;
    urn?: string | undefined;
    hash?: string | undefined;
    pmColour?: string | undefined;
    raw?: string | undefined;
    isRelevant?: boolean;
    isRedacted?: boolean;
    isHidden?: boolean;
    noteAudits?: NoteAuditDTO[] | undefined;
    auditSteps?: NoteExportDTO[] | undefined;
    noteDeltas?: NoteDeltaDTO[] | undefined;
    exportAudits?: ExportAuditDTO[] | undefined;
    sessionDate?: string | undefined;

    constructor(data?: INoteExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.sessionId = _data["sessionId"];
            this.deviceLatitude = _data["deviceLatitude"];
            this.deviceLongitude = _data["deviceLongitude"];
            this.declaredStart = _data["declaredStart"] ? new Date(_data["declaredStart"].toString()) : <any>undefined;
            this.declaredLatitude = _data["declaredLatitude"];
            this.declaredLongitude = _data["declaredLongitude"];
            this.body = _data["body"];
            this.type = _data["type"];
            this.declaredLocation = _data["declaredLocation"];
            this.protectiveMarkingId = _data["protectiveMarkingId"];
            this.informationManagementMarkerId = _data["informationManagementMarkerId"];
            this.isPrivate = _data["isPrivate"];
            this.isQuick = _data["isQuick"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDTO.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.ownerName = _data["ownerName"];
            this.ownerPosition = _data["ownerPosition"];
            this.ownerOrganisationId = _data["ownerOrganisationId"];
            this.ownerAgency = _data["ownerAgency"];
            this.ownerGroup = _data["ownerGroup"];
            this.ownerEmail = _data["ownerEmail"];
            this.ownerTimezone = _data["ownerTimezone"];
            this.ownerAccessControlGroup = _data["ownerAccessControlGroup"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.clientCreatedTime = _data["clientCreatedTime"] ? new Date(_data["clientCreatedTime"].toString()) : <any>undefined;
            this.clientUpdatedTime = _data["clientUpdatedTime"] ? new Date(_data["clientUpdatedTime"].toString()) : <any>undefined;
            this.deviceLocation = _data["deviceLocation"];
            this.declaredStartTime = _data["declaredStartTime"];
            this.protectiveMarking = _data["protectiveMarking"] ? ProtectiveMarking.fromJS(_data["protectiveMarking"]) : <any>undefined;
            this.protectiveMarkingName = _data["protectiveMarkingName"];
            this.informationManagementMarker = _data["informationManagementMarker"] ? InformationManagementMarker.fromJS(_data["informationManagementMarker"]) : <any>undefined;
            this.informationManagementMarkerName = _data["informationManagementMarkerName"];
            this.urn = _data["urn"];
            this.hash = _data["hash"];
            this.pmColour = _data["pmColour"];
            this.raw = _data["raw"];
            this.isRelevant = _data["isRelevant"];
            this.isRedacted = _data["isRedacted"];
            this.isHidden = _data["isHidden"];
            if (Array.isArray(_data["noteAudits"])) {
                this.noteAudits = [] as any;
                for (let item of _data["noteAudits"])
                    this.noteAudits!.push(NoteAuditDTO.fromJS(item));
            }
            if (Array.isArray(_data["auditSteps"])) {
                this.auditSteps = [] as any;
                for (let item of _data["auditSteps"])
                    this.auditSteps!.push(NoteExportDTO.fromJS(item));
            }
            if (Array.isArray(_data["noteDeltas"])) {
                this.noteDeltas = [] as any;
                for (let item of _data["noteDeltas"])
                    this.noteDeltas!.push(NoteDeltaDTO.fromJS(item));
            }
            if (Array.isArray(_data["exportAudits"])) {
                this.exportAudits = [] as any;
                for (let item of _data["exportAudits"])
                    this.exportAudits!.push(ExportAuditDTO.fromJS(item));
            }
            this.sessionDate = _data["sessionDate"];
        }
    }

    static fromJS(data: any): NoteExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NoteExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["sessionId"] = this.sessionId;
        data["deviceLatitude"] = this.deviceLatitude;
        data["deviceLongitude"] = this.deviceLongitude;
        data["declaredStart"] = this.declaredStart ? this.declaredStart.toISOString() : <any>undefined;
        data["declaredLatitude"] = this.declaredLatitude;
        data["declaredLongitude"] = this.declaredLongitude;
        data["body"] = this.body;
        data["type"] = this.type;
        data["declaredLocation"] = this.declaredLocation;
        data["protectiveMarkingId"] = this.protectiveMarkingId;
        data["informationManagementMarkerId"] = this.informationManagementMarkerId;
        data["isPrivate"] = this.isPrivate;
        data["isQuick"] = this.isQuick;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["ownerName"] = this.ownerName;
        data["ownerPosition"] = this.ownerPosition;
        data["ownerOrganisationId"] = this.ownerOrganisationId;
        data["ownerAgency"] = this.ownerAgency;
        data["ownerGroup"] = this.ownerGroup;
        data["ownerEmail"] = this.ownerEmail;
        data["ownerTimezone"] = this.ownerTimezone;
        data["ownerAccessControlGroup"] = this.ownerAccessControlGroup;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["clientCreatedTime"] = this.clientCreatedTime ? this.clientCreatedTime.toISOString() : <any>undefined;
        data["clientUpdatedTime"] = this.clientUpdatedTime ? this.clientUpdatedTime.toISOString() : <any>undefined;
        data["deviceLocation"] = this.deviceLocation;
        data["declaredStartTime"] = this.declaredStartTime;
        data["protectiveMarking"] = this.protectiveMarking ? this.protectiveMarking.toJSON() : <any>undefined;
        data["protectiveMarkingName"] = this.protectiveMarkingName;
        data["informationManagementMarker"] = this.informationManagementMarker ? this.informationManagementMarker.toJSON() : <any>undefined;
        data["informationManagementMarkerName"] = this.informationManagementMarkerName;
        data["urn"] = this.urn;
        data["hash"] = this.hash;
        data["pmColour"] = this.pmColour;
        data["raw"] = this.raw;
        data["isRelevant"] = this.isRelevant;
        data["isRedacted"] = this.isRedacted;
        data["isHidden"] = this.isHidden;
        if (Array.isArray(this.noteAudits)) {
            data["noteAudits"] = [];
            for (let item of this.noteAudits)
                data["noteAudits"].push(item.toJSON());
        }
        if (Array.isArray(this.auditSteps)) {
            data["auditSteps"] = [];
            for (let item of this.auditSteps)
                data["auditSteps"].push(item.toJSON());
        }
        if (Array.isArray(this.noteDeltas)) {
            data["noteDeltas"] = [];
            for (let item of this.noteDeltas)
                data["noteDeltas"].push(item.toJSON());
        }
        if (Array.isArray(this.exportAudits)) {
            data["exportAudits"] = [];
            for (let item of this.exportAudits)
                data["exportAudits"].push(item.toJSON());
        }
        data["sessionDate"] = this.sessionDate;
        return data;
    }
}

export interface INoteExportDTO {
    id?: number;
    title?: string | undefined;
    sessionId?: number;
    deviceLatitude?: number;
    deviceLongitude?: number;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    type?: string | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    keywords?: string[] | undefined;
    attachments?: AttachmentDTO[] | undefined;
    createdBy?: string | undefined;
    ownerName?: string | undefined;
    ownerPosition?: string | undefined;
    ownerOrganisationId?: string | undefined;
    ownerAgency?: string | undefined;
    ownerGroup?: string | undefined;
    ownerEmail?: string | undefined;
    ownerTimezone?: string | undefined;
    ownerAccessControlGroup?: AccessControlGroup;
    created?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedByName?: string | undefined;
    lastModified?: Date | undefined;
    clientCreatedTime?: Date | undefined;
    clientUpdatedTime?: Date | undefined;
    deviceLocation?: string | undefined;
    declaredStartTime?: string | undefined;
    protectiveMarking?: ProtectiveMarking | undefined;
    protectiveMarkingName?: string | undefined;
    informationManagementMarker?: InformationManagementMarker | undefined;
    informationManagementMarkerName?: string | undefined;
    urn?: string | undefined;
    hash?: string | undefined;
    pmColour?: string | undefined;
    raw?: string | undefined;
    isRelevant?: boolean;
    isRedacted?: boolean;
    isHidden?: boolean;
    noteAudits?: NoteAuditDTO[] | undefined;
    auditSteps?: NoteExportDTO[] | undefined;
    noteDeltas?: NoteDeltaDTO[] | undefined;
    exportAudits?: ExportAuditDTO[] | undefined;
    sessionDate?: string | undefined;
}

export class AttachmentDTO implements IAttachmentDTO {
    id?: number;
    noteId?: number;
    fileName?: string | undefined;
    isImage?: boolean;
    isRecording?: boolean;
    isVideo?: boolean;
    file?: string | undefined;
    isPdf?: boolean;
    deleted?: boolean;
    attachmentGuid?: string;
    createdBy?: string | undefined;
    created?: Date;
    lastModifiedBy?: string | undefined;
    lastModified?: Date | undefined;
    location?: string | undefined;
    hasTranscipt?: boolean;

    constructor(data?: IAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.noteId = _data["noteId"];
            this.fileName = _data["fileName"];
            this.isImage = _data["isImage"];
            this.isRecording = _data["isRecording"];
            this.isVideo = _data["isVideo"];
            this.file = _data["file"];
            this.isPdf = _data["isPdf"];
            this.deleted = _data["deleted"];
            this.attachmentGuid = _data["attachmentGuid"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.hasTranscipt = _data["hasTranscipt"];
        }
    }

    static fromJS(data: any): AttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["noteId"] = this.noteId;
        data["fileName"] = this.fileName;
        data["isImage"] = this.isImage;
        data["isRecording"] = this.isRecording;
        data["isVideo"] = this.isVideo;
        data["file"] = this.file;
        data["isPdf"] = this.isPdf;
        data["deleted"] = this.deleted;
        data["attachmentGuid"] = this.attachmentGuid;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["hasTranscipt"] = this.hasTranscipt;
        return data;
    }
}

export interface IAttachmentDTO {
    id?: number;
    noteId?: number;
    fileName?: string | undefined;
    isImage?: boolean;
    isRecording?: boolean;
    isVideo?: boolean;
    file?: string | undefined;
    isPdf?: boolean;
    deleted?: boolean;
    attachmentGuid?: string;
    createdBy?: string | undefined;
    created?: Date;
    lastModifiedBy?: string | undefined;
    lastModified?: Date | undefined;
    location?: string | undefined;
    hasTranscipt?: boolean;
}

export enum AccessControlGroup {
    Baseline = 0,
    Integrity = 1,
    CEO_Delegate = 2,
    OrganisationLawyer = 3,
    Admin = 4,
    Intelligence = 5,
    Supervisor = 6,
    Integration = 7,
    Restricted = 8,
}

export class ProtectiveMarking implements IProtectiveMarking {
    id?: number;
    name?: string | undefined;
    sort?: number;
    isRedacted?: boolean;
    isIMMRequired?: boolean;
    enabled?: boolean;
    isDefault?: boolean;
    colour?: string | undefined;

    constructor(data?: IProtectiveMarking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sort = _data["sort"];
            this.isRedacted = _data["isRedacted"];
            this.isIMMRequired = _data["isIMMRequired"];
            this.enabled = _data["enabled"];
            this.isDefault = _data["isDefault"];
            this.colour = _data["colour"];
        }
    }

    static fromJS(data: any): ProtectiveMarking {
        data = typeof data === 'object' ? data : {};
        let result = new ProtectiveMarking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sort"] = this.sort;
        data["isRedacted"] = this.isRedacted;
        data["isIMMRequired"] = this.isIMMRequired;
        data["enabled"] = this.enabled;
        data["isDefault"] = this.isDefault;
        data["colour"] = this.colour;
        return data;
    }
}

export interface IProtectiveMarking {
    id?: number;
    name?: string | undefined;
    sort?: number;
    isRedacted?: boolean;
    isIMMRequired?: boolean;
    enabled?: boolean;
    isDefault?: boolean;
    colour?: string | undefined;
}

export class InformationManagementMarker implements IInformationManagementMarker {
    id?: number;
    name?: string | undefined;
    sort?: number;
    enabled?: boolean;

    constructor(data?: IInformationManagementMarker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sort = _data["sort"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): InformationManagementMarker {
        data = typeof data === 'object' ? data : {};
        let result = new InformationManagementMarker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sort"] = this.sort;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IInformationManagementMarker {
    id?: number;
    name?: string | undefined;
    sort?: number;
    enabled?: boolean;
}

export class NoteAuditDTO implements INoteAuditDTO {
    id?: number;
    note?: string | undefined;
    userId?: string | undefined;
    hash?: string | undefined;

    constructor(data?: INoteAuditDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
            this.userId = _data["userId"];
            this.hash = _data["hash"];
        }
    }

    static fromJS(data: any): NoteAuditDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NoteAuditDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        data["userId"] = this.userId;
        data["hash"] = this.hash;
        return data;
    }
}

export interface INoteAuditDTO {
    id?: number;
    note?: string | undefined;
    userId?: string | undefined;
    hash?: string | undefined;
}

export class NoteDeltaDTO extends NoteExportDTO implements INoteDeltaDTO {
    changed?: boolean;
    titleChanged?: boolean;
    declaredStartChanged?: boolean;
    bodyChanged?: boolean;
    declaredLocationChanged?: boolean;
    createdChanged?: boolean;
    protectiveMarkingChanged?: boolean;
    informationManagementMarkerChanged?: boolean;
    clientCreatedTimeChanged?: boolean;
    clientUpdatedTimeChanged?: boolean;
    derivedHash?: string | undefined;
    hashMatch?: boolean;

    constructor(data?: INoteDeltaDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.changed = _data["changed"];
            this.titleChanged = _data["titleChanged"];
            this.declaredStartChanged = _data["declaredStartChanged"];
            this.bodyChanged = _data["bodyChanged"];
            this.declaredLocationChanged = _data["declaredLocationChanged"];
            this.createdChanged = _data["createdChanged"];
            this.protectiveMarkingChanged = _data["protectiveMarkingChanged"];
            this.informationManagementMarkerChanged = _data["informationManagementMarkerChanged"];
            this.clientCreatedTimeChanged = _data["clientCreatedTimeChanged"];
            this.clientUpdatedTimeChanged = _data["clientUpdatedTimeChanged"];
            this.derivedHash = _data["derivedHash"];
            this.hashMatch = _data["hashMatch"];
        }
    }

    static fromJS(data: any): NoteDeltaDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDeltaDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changed"] = this.changed;
        data["titleChanged"] = this.titleChanged;
        data["declaredStartChanged"] = this.declaredStartChanged;
        data["bodyChanged"] = this.bodyChanged;
        data["declaredLocationChanged"] = this.declaredLocationChanged;
        data["createdChanged"] = this.createdChanged;
        data["protectiveMarkingChanged"] = this.protectiveMarkingChanged;
        data["informationManagementMarkerChanged"] = this.informationManagementMarkerChanged;
        data["clientCreatedTimeChanged"] = this.clientCreatedTimeChanged;
        data["clientUpdatedTimeChanged"] = this.clientUpdatedTimeChanged;
        data["derivedHash"] = this.derivedHash;
        data["hashMatch"] = this.hashMatch;
        super.toJSON(data);
        return data;
    }
}

export interface INoteDeltaDTO extends INoteExportDTO {
    changed?: boolean;
    titleChanged?: boolean;
    declaredStartChanged?: boolean;
    bodyChanged?: boolean;
    declaredLocationChanged?: boolean;
    createdChanged?: boolean;
    protectiveMarkingChanged?: boolean;
    informationManagementMarkerChanged?: boolean;
    clientCreatedTimeChanged?: boolean;
    clientUpdatedTimeChanged?: boolean;
    derivedHash?: string | undefined;
    hashMatch?: boolean;
}

export class ExportAuditDTO implements IExportAuditDTO {
    id?: number;
    request?: string | undefined;
    export?: string | undefined;
    hash?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    timestamp?: Date;
    userEmail?: string | undefined;

    constructor(data?: IExportAuditDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.request = _data["request"];
            this.export = _data["export"];
            this.hash = _data["hash"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): ExportAuditDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportAuditDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["request"] = this.request;
        data["export"] = this.export;
        data["hash"] = this.hash;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export interface IExportAuditDTO {
    id?: number;
    request?: string | undefined;
    export?: string | undefined;
    hash?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    timestamp?: Date;
    userEmail?: string | undefined;
}

export class Tag implements ITag {
    tagName?: string | undefined;

    constructor(data?: ITag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagName = _data["tagName"];
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagName"] = this.tagName;
        return data;
    }
}

export interface ITag {
    tagName?: string | undefined;
}

export enum ExportType {
    Redacted = 1,
    Unredacted = 2,
    Interaction = 3,
    Statement = 4,
}

export class NoteSearchCriteria implements INoteSearchCriteria {
    searchTerm?: string | undefined;
    parsedQuery?: string | undefined;
    globalSearchReason?: string | undefined;
    searchType?: SearchType;
    exportTypes?: ExportType[] | undefined;
    searchStartDate?: Date | undefined;
    searchEndDate?: Date | undefined;
    isPrivate?: boolean | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    tags?: string[] | undefined;
    address?: string | undefined;
    workUnit?: string | undefined;
    password?: string | undefined;
    dateCreated?: boolean;
    now?: Date;
    userName?: string | undefined;
    userId?: string | undefined;
    isMonitor?: boolean | undefined;
    urn?: string | undefined;
    attachment?: string | undefined;
    offset?: number;
    pageSize?: number;

    constructor(data?: INoteSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            this.parsedQuery = _data["parsedQuery"];
            this.globalSearchReason = _data["globalSearchReason"];
            this.searchType = _data["searchType"];
            if (Array.isArray(_data["exportTypes"])) {
                this.exportTypes = [] as any;
                for (let item of _data["exportTypes"])
                    this.exportTypes!.push(item);
            }
            this.searchStartDate = _data["searchStartDate"] ? new Date(_data["searchStartDate"].toString()) : <any>undefined;
            this.searchEndDate = _data["searchEndDate"] ? new Date(_data["searchEndDate"].toString()) : <any>undefined;
            this.isPrivate = _data["isPrivate"];
            this.protectiveMarkingId = _data["protectiveMarkingId"];
            this.informationManagementMarkerId = _data["informationManagementMarkerId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.address = _data["address"];
            this.workUnit = _data["workUnit"];
            this.password = _data["password"];
            this.dateCreated = _data["dateCreated"];
            this.now = _data["now"] ? new Date(_data["now"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.isMonitor = _data["isMonitor"];
            this.urn = _data["urn"];
            this.attachment = _data["attachment"];
            this.offset = _data["offset"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): NoteSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new NoteSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        data["parsedQuery"] = this.parsedQuery;
        data["globalSearchReason"] = this.globalSearchReason;
        data["searchType"] = this.searchType;
        if (Array.isArray(this.exportTypes)) {
            data["exportTypes"] = [];
            for (let item of this.exportTypes)
                data["exportTypes"].push(item);
        }
        data["searchStartDate"] = this.searchStartDate ? this.searchStartDate.toISOString() : <any>undefined;
        data["searchEndDate"] = this.searchEndDate ? this.searchEndDate.toISOString() : <any>undefined;
        data["isPrivate"] = this.isPrivate;
        data["protectiveMarkingId"] = this.protectiveMarkingId;
        data["informationManagementMarkerId"] = this.informationManagementMarkerId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["address"] = this.address;
        data["workUnit"] = this.workUnit;
        data["password"] = this.password;
        data["dateCreated"] = this.dateCreated;
        data["now"] = this.now ? this.now.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["isMonitor"] = this.isMonitor;
        data["urn"] = this.urn;
        data["attachment"] = this.attachment;
        data["offset"] = this.offset;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface INoteSearchCriteria {
    searchTerm?: string | undefined;
    parsedQuery?: string | undefined;
    globalSearchReason?: string | undefined;
    searchType?: SearchType;
    exportTypes?: ExportType[] | undefined;
    searchStartDate?: Date | undefined;
    searchEndDate?: Date | undefined;
    isPrivate?: boolean | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    tags?: string[] | undefined;
    address?: string | undefined;
    workUnit?: string | undefined;
    password?: string | undefined;
    dateCreated?: boolean;
    now?: Date;
    userName?: string | undefined;
    userId?: string | undefined;
    isMonitor?: boolean | undefined;
    urn?: string | undefined;
    attachment?: string | undefined;
    offset?: number;
    pageSize?: number;
}

export enum SearchType {
    Standard = 1,
    Global = 2,
    Statement = 3,
}

export class NoteAuditViewModel implements INoteAuditViewModel {
    noteAudits?: NoteAuditDTO[] | undefined;

    constructor(data?: INoteAuditViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["noteAudits"])) {
                this.noteAudits = [] as any;
                for (let item of _data["noteAudits"])
                    this.noteAudits!.push(NoteAuditDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NoteAuditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NoteAuditViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.noteAudits)) {
            data["noteAudits"] = [];
            for (let item of this.noteAudits)
                data["noteAudits"].push(item.toJSON());
        }
        return data;
    }
}

export interface INoteAuditViewModel {
    noteAudits?: NoteAuditDTO[] | undefined;
}

export class ExportAuditViewModel implements IExportAuditViewModel {
    exportAudits?: ExportAuditDTO[] | undefined;

    constructor(data?: IExportAuditViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["exportAudits"])) {
                this.exportAudits = [] as any;
                for (let item of _data["exportAudits"])
                    this.exportAudits!.push(ExportAuditDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportAuditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportAuditViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.exportAudits)) {
            data["exportAudits"] = [];
            for (let item of this.exportAudits)
                data["exportAudits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportAuditViewModel {
    exportAudits?: ExportAuditDTO[] | undefined;
}

export class SearchAuditViewModel implements ISearchAuditViewModel {
    searchAudits?: SearchAuditDTO[] | undefined;

    constructor(data?: ISearchAuditViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["searchAudits"])) {
                this.searchAudits = [] as any;
                for (let item of _data["searchAudits"])
                    this.searchAudits!.push(SearchAuditDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchAuditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAuditViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchAudits)) {
            data["searchAudits"] = [];
            for (let item of this.searchAudits)
                data["searchAudits"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchAuditViewModel {
    searchAudits?: SearchAuditDTO[] | undefined;
}

export class SearchAuditDTO implements ISearchAuditDTO {
    id?: number;
    request?: string | undefined;
    response?: string | undefined;
    hash?: string | undefined;
    userEmail?: string | undefined;
    timestamp?: Date;

    constructor(data?: ISearchAuditDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.request = _data["request"];
            this.response = _data["response"];
            this.hash = _data["hash"];
            this.userEmail = _data["userEmail"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchAuditDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAuditDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["request"] = this.request;
        data["response"] = this.response;
        data["hash"] = this.hash;
        data["userEmail"] = this.userEmail;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISearchAuditDTO {
    id?: number;
    request?: string | undefined;
    response?: string | undefined;
    hash?: string | undefined;
    userEmail?: string | undefined;
    timestamp?: Date;
}

export class CreateNoteCommand implements ICreateNoteCommand {
    title?: string | undefined;
    deviceLatitude?: number | undefined;
    deviceLongitude?: number | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;
    clientCreatedTime?: Date | undefined;

    constructor(data?: ICreateNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.deviceLatitude = _data["deviceLatitude"];
            this.deviceLongitude = _data["deviceLongitude"];
            this.declaredStart = _data["declaredStart"] ? new Date(_data["declaredStart"].toString()) : <any>undefined;
            this.declaredLatitude = _data["declaredLatitude"];
            this.declaredLongitude = _data["declaredLongitude"];
            this.body = _data["body"];
            this.isPrivate = _data["isPrivate"];
            this.isQuick = _data["isQuick"];
            this.declaredLocation = _data["declaredLocation"];
            this.protectiveMarkingId = _data["protectiveMarkingId"];
            this.informationManagementMarkerId = _data["informationManagementMarkerId"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            this.urn = _data["urn"];
            this.deviceLocation = _data["deviceLocation"];
            this.clientCreatedTime = _data["clientCreatedTime"] ? new Date(_data["clientCreatedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["deviceLatitude"] = this.deviceLatitude;
        data["deviceLongitude"] = this.deviceLongitude;
        data["declaredStart"] = this.declaredStart ? this.declaredStart.toISOString() : <any>undefined;
        data["declaredLatitude"] = this.declaredLatitude;
        data["declaredLongitude"] = this.declaredLongitude;
        data["body"] = this.body;
        data["isPrivate"] = this.isPrivate;
        data["isQuick"] = this.isQuick;
        data["declaredLocation"] = this.declaredLocation;
        data["protectiveMarkingId"] = this.protectiveMarkingId;
        data["informationManagementMarkerId"] = this.informationManagementMarkerId;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        data["urn"] = this.urn;
        data["deviceLocation"] = this.deviceLocation;
        data["clientCreatedTime"] = this.clientCreatedTime ? this.clientCreatedTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateNoteCommand {
    title?: string | undefined;
    deviceLatitude?: number | undefined;
    deviceLongitude?: number | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;
    clientCreatedTime?: Date | undefined;
}

export class UpsertNoteResultViewModel implements IUpsertNoteResultViewModel {
    noteId?: number;
    contentCheck?: string | undefined;

    constructor(data?: IUpsertNoteResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteId = _data["noteId"];
            this.contentCheck = _data["contentCheck"];
        }
    }

    static fromJS(data: any): UpsertNoteResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertNoteResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteId"] = this.noteId;
        data["contentCheck"] = this.contentCheck;
        return data;
    }
}

export interface IUpsertNoteResultViewModel {
    noteId?: number;
    contentCheck?: string | undefined;
}

export class CreateNoteWithHistoryCommand implements ICreateNoteWithHistoryCommand {
    title?: string | undefined;
    deviceLatitude?: number | undefined;
    deviceLongitude?: number | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;
    clientCreatedTime?: Date;
    clientUpdatedTime?: Date;
    history?: CreateNote[] | undefined;

    constructor(data?: ICreateNoteWithHistoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.deviceLatitude = _data["deviceLatitude"];
            this.deviceLongitude = _data["deviceLongitude"];
            this.declaredStart = _data["declaredStart"] ? new Date(_data["declaredStart"].toString()) : <any>undefined;
            this.declaredLatitude = _data["declaredLatitude"];
            this.declaredLongitude = _data["declaredLongitude"];
            this.body = _data["body"];
            this.isPrivate = _data["isPrivate"];
            this.isQuick = _data["isQuick"];
            this.declaredLocation = _data["declaredLocation"];
            this.protectiveMarkingId = _data["protectiveMarkingId"];
            this.informationManagementMarkerId = _data["informationManagementMarkerId"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            this.urn = _data["urn"];
            this.deviceLocation = _data["deviceLocation"];
            this.clientCreatedTime = _data["clientCreatedTime"] ? new Date(_data["clientCreatedTime"].toString()) : <any>undefined;
            this.clientUpdatedTime = _data["clientUpdatedTime"] ? new Date(_data["clientUpdatedTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(CreateNote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateNoteWithHistoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNoteWithHistoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["deviceLatitude"] = this.deviceLatitude;
        data["deviceLongitude"] = this.deviceLongitude;
        data["declaredStart"] = this.declaredStart ? this.declaredStart.toISOString() : <any>undefined;
        data["declaredLatitude"] = this.declaredLatitude;
        data["declaredLongitude"] = this.declaredLongitude;
        data["body"] = this.body;
        data["isPrivate"] = this.isPrivate;
        data["isQuick"] = this.isQuick;
        data["declaredLocation"] = this.declaredLocation;
        data["protectiveMarkingId"] = this.protectiveMarkingId;
        data["informationManagementMarkerId"] = this.informationManagementMarkerId;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        data["urn"] = this.urn;
        data["deviceLocation"] = this.deviceLocation;
        data["clientCreatedTime"] = this.clientCreatedTime ? this.clientCreatedTime.toISOString() : <any>undefined;
        data["clientUpdatedTime"] = this.clientUpdatedTime ? this.clientUpdatedTime.toISOString() : <any>undefined;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateNoteWithHistoryCommand {
    title?: string | undefined;
    deviceLatitude?: number | undefined;
    deviceLongitude?: number | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;
    clientCreatedTime?: Date;
    clientUpdatedTime?: Date;
    history?: CreateNote[] | undefined;
}

export class CreateNote implements ICreateNote {
    title?: string | undefined;
    deviceLatitude?: number | undefined;
    deviceLongitude?: number | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;
    clientCreatedTime?: Date;
    clientUpdatedTime?: Date;

    constructor(data?: ICreateNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.deviceLatitude = _data["deviceLatitude"];
            this.deviceLongitude = _data["deviceLongitude"];
            this.declaredStart = _data["declaredStart"] ? new Date(_data["declaredStart"].toString()) : <any>undefined;
            this.declaredLatitude = _data["declaredLatitude"];
            this.declaredLongitude = _data["declaredLongitude"];
            this.body = _data["body"];
            this.isPrivate = _data["isPrivate"];
            this.isQuick = _data["isQuick"];
            this.declaredLocation = _data["declaredLocation"];
            this.protectiveMarkingId = _data["protectiveMarkingId"];
            this.informationManagementMarkerId = _data["informationManagementMarkerId"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            this.urn = _data["urn"];
            this.deviceLocation = _data["deviceLocation"];
            this.clientCreatedTime = _data["clientCreatedTime"] ? new Date(_data["clientCreatedTime"].toString()) : <any>undefined;
            this.clientUpdatedTime = _data["clientUpdatedTime"] ? new Date(_data["clientUpdatedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateNote {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["deviceLatitude"] = this.deviceLatitude;
        data["deviceLongitude"] = this.deviceLongitude;
        data["declaredStart"] = this.declaredStart ? this.declaredStart.toISOString() : <any>undefined;
        data["declaredLatitude"] = this.declaredLatitude;
        data["declaredLongitude"] = this.declaredLongitude;
        data["body"] = this.body;
        data["isPrivate"] = this.isPrivate;
        data["isQuick"] = this.isQuick;
        data["declaredLocation"] = this.declaredLocation;
        data["protectiveMarkingId"] = this.protectiveMarkingId;
        data["informationManagementMarkerId"] = this.informationManagementMarkerId;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        data["urn"] = this.urn;
        data["deviceLocation"] = this.deviceLocation;
        data["clientCreatedTime"] = this.clientCreatedTime ? this.clientCreatedTime.toISOString() : <any>undefined;
        data["clientUpdatedTime"] = this.clientUpdatedTime ? this.clientUpdatedTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateNote {
    title?: string | undefined;
    deviceLatitude?: number | undefined;
    deviceLongitude?: number | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;
    clientCreatedTime?: Date;
    clientUpdatedTime?: Date;
}

export class UpdateNoteCommand implements IUpdateNoteCommand {
    id?: number;
    title?: string | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    deviceLatitude?: number;
    deviceLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;

    constructor(data?: IUpdateNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.declaredStart = _data["declaredStart"] ? new Date(_data["declaredStart"].toString()) : <any>undefined;
            this.declaredLatitude = _data["declaredLatitude"];
            this.declaredLongitude = _data["declaredLongitude"];
            this.deviceLatitude = _data["deviceLatitude"];
            this.deviceLongitude = _data["deviceLongitude"];
            this.body = _data["body"];
            this.isPrivate = _data["isPrivate"];
            this.isQuick = _data["isQuick"];
            this.declaredLocation = _data["declaredLocation"];
            this.protectiveMarkingId = _data["protectiveMarkingId"];
            this.informationManagementMarkerId = _data["informationManagementMarkerId"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            this.urn = _data["urn"];
            this.deviceLocation = _data["deviceLocation"];
        }
    }

    static fromJS(data: any): UpdateNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["declaredStart"] = this.declaredStart ? this.declaredStart.toISOString() : <any>undefined;
        data["declaredLatitude"] = this.declaredLatitude;
        data["declaredLongitude"] = this.declaredLongitude;
        data["deviceLatitude"] = this.deviceLatitude;
        data["deviceLongitude"] = this.deviceLongitude;
        data["body"] = this.body;
        data["isPrivate"] = this.isPrivate;
        data["isQuick"] = this.isQuick;
        data["declaredLocation"] = this.declaredLocation;
        data["protectiveMarkingId"] = this.protectiveMarkingId;
        data["informationManagementMarkerId"] = this.informationManagementMarkerId;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        data["urn"] = this.urn;
        data["deviceLocation"] = this.deviceLocation;
        return data;
    }
}

export interface IUpdateNoteCommand {
    id?: number;
    title?: string | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    deviceLatitude?: number;
    deviceLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;
}

export class UpdateNoteWithHistoryCommand implements IUpdateNoteWithHistoryCommand {
    id?: number;
    title?: string | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    deviceLatitude?: number;
    deviceLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;
    clientUpdatedTime?: Date;
    history?: UpdateNote[] | undefined;

    constructor(data?: IUpdateNoteWithHistoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.declaredStart = _data["declaredStart"] ? new Date(_data["declaredStart"].toString()) : <any>undefined;
            this.declaredLatitude = _data["declaredLatitude"];
            this.declaredLongitude = _data["declaredLongitude"];
            this.deviceLatitude = _data["deviceLatitude"];
            this.deviceLongitude = _data["deviceLongitude"];
            this.body = _data["body"];
            this.isPrivate = _data["isPrivate"];
            this.isQuick = _data["isQuick"];
            this.declaredLocation = _data["declaredLocation"];
            this.protectiveMarkingId = _data["protectiveMarkingId"];
            this.informationManagementMarkerId = _data["informationManagementMarkerId"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            this.urn = _data["urn"];
            this.deviceLocation = _data["deviceLocation"];
            this.clientUpdatedTime = _data["clientUpdatedTime"] ? new Date(_data["clientUpdatedTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(UpdateNote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNoteWithHistoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNoteWithHistoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["declaredStart"] = this.declaredStart ? this.declaredStart.toISOString() : <any>undefined;
        data["declaredLatitude"] = this.declaredLatitude;
        data["declaredLongitude"] = this.declaredLongitude;
        data["deviceLatitude"] = this.deviceLatitude;
        data["deviceLongitude"] = this.deviceLongitude;
        data["body"] = this.body;
        data["isPrivate"] = this.isPrivate;
        data["isQuick"] = this.isQuick;
        data["declaredLocation"] = this.declaredLocation;
        data["protectiveMarkingId"] = this.protectiveMarkingId;
        data["informationManagementMarkerId"] = this.informationManagementMarkerId;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        data["urn"] = this.urn;
        data["deviceLocation"] = this.deviceLocation;
        data["clientUpdatedTime"] = this.clientUpdatedTime ? this.clientUpdatedTime.toISOString() : <any>undefined;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateNoteWithHistoryCommand {
    id?: number;
    title?: string | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    deviceLatitude?: number;
    deviceLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;
    clientUpdatedTime?: Date;
    history?: UpdateNote[] | undefined;
}

export class UpdateNote implements IUpdateNote {
    title?: string | undefined;
    deviceLatitude?: number | undefined;
    deviceLongitude?: number | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;
    clientCreatedTime?: Date;
    clientUpdatedTime?: Date;

    constructor(data?: IUpdateNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.deviceLatitude = _data["deviceLatitude"];
            this.deviceLongitude = _data["deviceLongitude"];
            this.declaredStart = _data["declaredStart"] ? new Date(_data["declaredStart"].toString()) : <any>undefined;
            this.declaredLatitude = _data["declaredLatitude"];
            this.declaredLongitude = _data["declaredLongitude"];
            this.body = _data["body"];
            this.isPrivate = _data["isPrivate"];
            this.isQuick = _data["isQuick"];
            this.declaredLocation = _data["declaredLocation"];
            this.protectiveMarkingId = _data["protectiveMarkingId"];
            this.informationManagementMarkerId = _data["informationManagementMarkerId"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            this.urn = _data["urn"];
            this.deviceLocation = _data["deviceLocation"];
            this.clientCreatedTime = _data["clientCreatedTime"] ? new Date(_data["clientCreatedTime"].toString()) : <any>undefined;
            this.clientUpdatedTime = _data["clientUpdatedTime"] ? new Date(_data["clientUpdatedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateNote {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["deviceLatitude"] = this.deviceLatitude;
        data["deviceLongitude"] = this.deviceLongitude;
        data["declaredStart"] = this.declaredStart ? this.declaredStart.toISOString() : <any>undefined;
        data["declaredLatitude"] = this.declaredLatitude;
        data["declaredLongitude"] = this.declaredLongitude;
        data["body"] = this.body;
        data["isPrivate"] = this.isPrivate;
        data["isQuick"] = this.isQuick;
        data["declaredLocation"] = this.declaredLocation;
        data["protectiveMarkingId"] = this.protectiveMarkingId;
        data["informationManagementMarkerId"] = this.informationManagementMarkerId;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        data["urn"] = this.urn;
        data["deviceLocation"] = this.deviceLocation;
        data["clientCreatedTime"] = this.clientCreatedTime ? this.clientCreatedTime.toISOString() : <any>undefined;
        data["clientUpdatedTime"] = this.clientUpdatedTime ? this.clientUpdatedTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateNote {
    title?: string | undefined;
    deviceLatitude?: number | undefined;
    deviceLongitude?: number | undefined;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    keywords?: string[] | undefined;
    urn?: string | undefined;
    deviceLocation?: string | undefined;
    clientCreatedTime?: Date;
    clientUpdatedTime?: Date;
}

export class UserNotesHistoryViewModel implements IUserNotesHistoryViewModel {
    declaredLocations?: DeclaredLocation[] | undefined;
    uniqueReferences?: string[] | undefined;

    constructor(data?: IUserNotesHistoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["declaredLocations"])) {
                this.declaredLocations = [] as any;
                for (let item of _data["declaredLocations"])
                    this.declaredLocations!.push(DeclaredLocation.fromJS(item));
            }
            if (Array.isArray(_data["uniqueReferences"])) {
                this.uniqueReferences = [] as any;
                for (let item of _data["uniqueReferences"])
                    this.uniqueReferences!.push(item);
            }
        }
    }

    static fromJS(data: any): UserNotesHistoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotesHistoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.declaredLocations)) {
            data["declaredLocations"] = [];
            for (let item of this.declaredLocations)
                data["declaredLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.uniqueReferences)) {
            data["uniqueReferences"] = [];
            for (let item of this.uniqueReferences)
                data["uniqueReferences"].push(item);
        }
        return data;
    }
}

export interface IUserNotesHistoryViewModel {
    declaredLocations?: DeclaredLocation[] | undefined;
    uniqueReferences?: string[] | undefined;
}

export class DeclaredLocation implements IDeclaredLocation {
    name?: string | undefined;
    latitude?: number;
    longitude?: number;

    constructor(data?: IDeclaredLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): DeclaredLocation {
        data = typeof data === 'object' ? data : {};
        let result = new DeclaredLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IDeclaredLocation {
    name?: string | undefined;
    latitude?: number;
    longitude?: number;
}

export class SessionViewModel implements ISessionViewModel {
    notes?: NoteDTO[] | undefined;

    constructor(data?: ISessionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SessionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SessionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISessionViewModel {
    notes?: NoteDTO[] | undefined;
}

export class NoteDTO implements INoteDTO {
    id?: number;
    title?: string | undefined;
    sessionId?: number;
    deviceLatitude?: number;
    deviceLongitude?: number;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    type?: string | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    keywords?: string[] | undefined;
    attachments?: AttachmentDTO[] | undefined;
    createdBy?: string | undefined;
    ownerName?: string | undefined;
    ownerGroup?: string | undefined;
    ownerEmail?: string | undefined;
    created?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedByName?: string | undefined;
    lastModified?: Date | undefined;
    clientCreatedTime?: Date | undefined;
    clientUpdatedTime?: Date | undefined;
    deviceLocation?: string | undefined;
    declaredStartTime?: string | undefined;
    urn?: string | undefined;
    protectiveMarking?: ProtectiveMarking | undefined;
    protectiveMarkingName?: string | undefined;
    informationManagementMarker?: InformationManagementMarker | undefined;
    informationManagementMarkerName?: string | undefined;
    hash?: string | undefined;
    pmColour?: string | undefined;
    raw?: string | undefined;

    constructor(data?: INoteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.sessionId = _data["sessionId"];
            this.deviceLatitude = _data["deviceLatitude"];
            this.deviceLongitude = _data["deviceLongitude"];
            this.declaredStart = _data["declaredStart"] ? new Date(_data["declaredStart"].toString()) : <any>undefined;
            this.declaredLatitude = _data["declaredLatitude"];
            this.declaredLongitude = _data["declaredLongitude"];
            this.body = _data["body"];
            this.type = _data["type"];
            this.declaredLocation = _data["declaredLocation"];
            this.protectiveMarkingId = _data["protectiveMarkingId"];
            this.informationManagementMarkerId = _data["informationManagementMarkerId"];
            this.isPrivate = _data["isPrivate"];
            this.isQuick = _data["isQuick"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDTO.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.ownerName = _data["ownerName"];
            this.ownerGroup = _data["ownerGroup"];
            this.ownerEmail = _data["ownerEmail"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.clientCreatedTime = _data["clientCreatedTime"] ? new Date(_data["clientCreatedTime"].toString()) : <any>undefined;
            this.clientUpdatedTime = _data["clientUpdatedTime"] ? new Date(_data["clientUpdatedTime"].toString()) : <any>undefined;
            this.deviceLocation = _data["deviceLocation"];
            this.declaredStartTime = _data["declaredStartTime"];
            this.urn = _data["urn"];
            this.protectiveMarking = _data["protectiveMarking"] ? ProtectiveMarking.fromJS(_data["protectiveMarking"]) : <any>undefined;
            this.protectiveMarkingName = _data["protectiveMarkingName"];
            this.informationManagementMarker = _data["informationManagementMarker"] ? InformationManagementMarker.fromJS(_data["informationManagementMarker"]) : <any>undefined;
            this.informationManagementMarkerName = _data["informationManagementMarkerName"];
            this.hash = _data["hash"];
            this.pmColour = _data["pmColour"];
            this.raw = _data["raw"];
        }
    }

    static fromJS(data: any): NoteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["sessionId"] = this.sessionId;
        data["deviceLatitude"] = this.deviceLatitude;
        data["deviceLongitude"] = this.deviceLongitude;
        data["declaredStart"] = this.declaredStart ? this.declaredStart.toISOString() : <any>undefined;
        data["declaredLatitude"] = this.declaredLatitude;
        data["declaredLongitude"] = this.declaredLongitude;
        data["body"] = this.body;
        data["type"] = this.type;
        data["declaredLocation"] = this.declaredLocation;
        data["protectiveMarkingId"] = this.protectiveMarkingId;
        data["informationManagementMarkerId"] = this.informationManagementMarkerId;
        data["isPrivate"] = this.isPrivate;
        data["isQuick"] = this.isQuick;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["ownerName"] = this.ownerName;
        data["ownerGroup"] = this.ownerGroup;
        data["ownerEmail"] = this.ownerEmail;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["clientCreatedTime"] = this.clientCreatedTime ? this.clientCreatedTime.toISOString() : <any>undefined;
        data["clientUpdatedTime"] = this.clientUpdatedTime ? this.clientUpdatedTime.toISOString() : <any>undefined;
        data["deviceLocation"] = this.deviceLocation;
        data["declaredStartTime"] = this.declaredStartTime;
        data["urn"] = this.urn;
        data["protectiveMarking"] = this.protectiveMarking ? this.protectiveMarking.toJSON() : <any>undefined;
        data["protectiveMarkingName"] = this.protectiveMarkingName;
        data["informationManagementMarker"] = this.informationManagementMarker ? this.informationManagementMarker.toJSON() : <any>undefined;
        data["informationManagementMarkerName"] = this.informationManagementMarkerName;
        data["hash"] = this.hash;
        data["pmColour"] = this.pmColour;
        data["raw"] = this.raw;
        return data;
    }
}

export interface INoteDTO {
    id?: number;
    title?: string | undefined;
    sessionId?: number;
    deviceLatitude?: number;
    deviceLongitude?: number;
    declaredStart?: Date;
    declaredLatitude?: number;
    declaredLongitude?: number;
    body?: string | undefined;
    type?: string | undefined;
    declaredLocation?: string | undefined;
    protectiveMarkingId?: number | undefined;
    informationManagementMarkerId?: number | undefined;
    isPrivate?: boolean;
    isQuick?: boolean | undefined;
    keywords?: string[] | undefined;
    attachments?: AttachmentDTO[] | undefined;
    createdBy?: string | undefined;
    ownerName?: string | undefined;
    ownerGroup?: string | undefined;
    ownerEmail?: string | undefined;
    created?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedByName?: string | undefined;
    lastModified?: Date | undefined;
    clientCreatedTime?: Date | undefined;
    clientUpdatedTime?: Date | undefined;
    deviceLocation?: string | undefined;
    declaredStartTime?: string | undefined;
    urn?: string | undefined;
    protectiveMarking?: ProtectiveMarking | undefined;
    protectiveMarkingName?: string | undefined;
    informationManagementMarker?: InformationManagementMarker | undefined;
    informationManagementMarkerName?: string | undefined;
    hash?: string | undefined;
    pmColour?: string | undefined;
    raw?: string | undefined;
}

export class SearchNotesViewModel implements ISearchNotesViewModel {
    notes?: NoteDTO[] | undefined;

    constructor(data?: ISearchNotesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchNotesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchNotesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchNotesViewModel {
    notes?: NoteDTO[] | undefined;
}

export class SearchFilter extends NoteSearchCriteria implements ISearchFilter {
    relevantIds?: number[] | undefined;
    attachments?: string[] | undefined;

    constructor(data?: ISearchFilter) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["relevantIds"])) {
                this.relevantIds = [] as any;
                for (let item of _data["relevantIds"])
                    this.relevantIds!.push(item);
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.relevantIds)) {
            data["relevantIds"] = [];
            for (let item of this.relevantIds)
                data["relevantIds"].push(item);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISearchFilter extends INoteSearchCriteria {
    relevantIds?: number[] | undefined;
    attachments?: string[] | undefined;
}

export class CreateTranscriptionCommand implements ICreateTranscriptionCommand {
    attachmentId?: string;
    result?: string | undefined;
    succeeded?: boolean;
    transcriptStatus?: TranscriptStatus;

    constructor(data?: ICreateTranscriptionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentId = _data["attachmentId"];
            this.result = _data["result"];
            this.succeeded = _data["succeeded"];
            this.transcriptStatus = _data["transcriptStatus"];
        }
    }

    static fromJS(data: any): CreateTranscriptionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTranscriptionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentId"] = this.attachmentId;
        data["result"] = this.result;
        data["succeeded"] = this.succeeded;
        data["transcriptStatus"] = this.transcriptStatus;
        return data;
    }
}

export interface ICreateTranscriptionCommand {
    attachmentId?: string;
    result?: string | undefined;
    succeeded?: boolean;
    transcriptStatus?: TranscriptStatus;
}

export enum TranscriptStatus {
    DRAFT = 0,
    FINALIZED = 1,
    DISCARDED = 2,
}

export class TranscriptionFailedCommand implements ITranscriptionFailedCommand {
    attachmentId?: string;

    constructor(data?: ITranscriptionFailedCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentId = _data["attachmentId"];
        }
    }

    static fromJS(data: any): TranscriptionFailedCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptionFailedCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentId"] = this.attachmentId;
        return data;
    }
}

export interface ITranscriptionFailedCommand {
    attachmentId?: string;
}

export class TranscriptDto implements ITranscriptDto {
    id?: number;
    content?: string | undefined;
    transciptStatus?: TranscriptStatus;
    attachments?: AttachmentDTO[] | undefined;

    constructor(data?: ITranscriptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.transciptStatus = _data["transciptStatus"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranscriptDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["transciptStatus"] = this.transciptStatus;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranscriptDto {
    id?: number;
    content?: string | undefined;
    transciptStatus?: TranscriptStatus;
    attachments?: AttachmentDTO[] | undefined;
}

export class UpdateTranscriptionCommand implements IUpdateTranscriptionCommand {
    attachmentId?: string;
    content?: string | undefined;
    status?: TranscriptStatus;

    constructor(data?: IUpdateTranscriptionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentId = _data["attachmentId"];
            this.content = _data["content"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateTranscriptionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTranscriptionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentId"] = this.attachmentId;
        data["content"] = this.content;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateTranscriptionCommand {
    attachmentId?: string;
    content?: string | undefined;
    status?: TranscriptStatus;
}

export class CreateUserCommand implements ICreateUserCommand {
    phone?: string | undefined;
    interfaceTimeZone?: string | undefined;
    organisation?: string | undefined;
    position?: string | undefined;
    workUnit?: string | undefined;
    employeeId?: string | undefined;
    accessControlGroup?: AccessControlGroup;
    otp?: string | undefined;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.interfaceTimeZone = _data["interfaceTimeZone"];
            this.organisation = _data["organisation"];
            this.position = _data["position"];
            this.workUnit = _data["workUnit"];
            this.employeeId = _data["employeeId"];
            this.accessControlGroup = _data["accessControlGroup"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["interfaceTimeZone"] = this.interfaceTimeZone;
        data["organisation"] = this.organisation;
        data["position"] = this.position;
        data["workUnit"] = this.workUnit;
        data["employeeId"] = this.employeeId;
        data["accessControlGroup"] = this.accessControlGroup;
        data["otp"] = this.otp;
        return data;
    }
}

export interface ICreateUserCommand {
    phone?: string | undefined;
    interfaceTimeZone?: string | undefined;
    organisation?: string | undefined;
    position?: string | undefined;
    workUnit?: string | undefined;
    employeeId?: string | undefined;
    accessControlGroup?: AccessControlGroup;
    otp?: string | undefined;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    phone?: string | undefined;
    agency?: string | undefined;
    workGroup?: string | undefined;
    interfaceTimeZone?: string | undefined;
    organisationIdentifier?: string | undefined;
    accessControlGroup?: AccessControlGroup;
    requestedAccessControlGroup?: AccessControlGroup;
    otp?: string | undefined;
    disabled?: boolean;

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.position = _data["position"];
            this.phone = _data["phone"];
            this.agency = _data["agency"];
            this.workGroup = _data["workGroup"];
            this.interfaceTimeZone = _data["interfaceTimeZone"];
            this.organisationIdentifier = _data["organisationIdentifier"];
            this.accessControlGroup = _data["accessControlGroup"];
            this.requestedAccessControlGroup = _data["requestedAccessControlGroup"];
            this.otp = _data["otp"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["position"] = this.position;
        data["phone"] = this.phone;
        data["agency"] = this.agency;
        data["workGroup"] = this.workGroup;
        data["interfaceTimeZone"] = this.interfaceTimeZone;
        data["organisationIdentifier"] = this.organisationIdentifier;
        data["accessControlGroup"] = this.accessControlGroup;
        data["requestedAccessControlGroup"] = this.requestedAccessControlGroup;
        data["otp"] = this.otp;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface IUpdateUserCommand {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    phone?: string | undefined;
    agency?: string | undefined;
    workGroup?: string | undefined;
    interfaceTimeZone?: string | undefined;
    organisationIdentifier?: string | undefined;
    accessControlGroup?: AccessControlGroup;
    requestedAccessControlGroup?: AccessControlGroup;
    otp?: string | undefined;
    disabled?: boolean;
}

export class UserViewModel implements IUserViewModel {
    user?: UserDTO | undefined;

    constructor(data?: IUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDTO.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserViewModel {
    user?: UserDTO | undefined;
}

export class UserDTO implements IUserDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;
    agency?: string | undefined;
    workGroup?: string | undefined;
    phone?: string | undefined;
    interfaceTimeZone?: string | undefined;
    organisationIdentifier?: string | undefined;
    accessControlGroup?: AccessControlGroup;
    requestedAccessControlGroup?: AccessControlGroup;
    accessControlGroupLabel?: string | undefined;
    disabled?: boolean;

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.position = _data["position"];
            this.agency = _data["agency"];
            this.workGroup = _data["workGroup"];
            this.phone = _data["phone"];
            this.interfaceTimeZone = _data["interfaceTimeZone"];
            this.organisationIdentifier = _data["organisationIdentifier"];
            this.accessControlGroup = _data["accessControlGroup"];
            this.requestedAccessControlGroup = _data["requestedAccessControlGroup"];
            this.accessControlGroupLabel = _data["accessControlGroupLabel"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["position"] = this.position;
        data["agency"] = this.agency;
        data["workGroup"] = this.workGroup;
        data["phone"] = this.phone;
        data["interfaceTimeZone"] = this.interfaceTimeZone;
        data["organisationIdentifier"] = this.organisationIdentifier;
        data["accessControlGroup"] = this.accessControlGroup;
        data["requestedAccessControlGroup"] = this.requestedAccessControlGroup;
        data["accessControlGroupLabel"] = this.accessControlGroupLabel;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface IUserDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;
    agency?: string | undefined;
    workGroup?: string | undefined;
    phone?: string | undefined;
    interfaceTimeZone?: string | undefined;
    organisationIdentifier?: string | undefined;
    accessControlGroup?: AccessControlGroup;
    requestedAccessControlGroup?: AccessControlGroup;
    accessControlGroupLabel?: string | undefined;
    disabled?: boolean;
}

export class UserAuditLogViewModel implements IUserAuditLogViewModel {
    userLogs?: UserAuditLogDTO[] | undefined;

    constructor(data?: IUserAuditLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userLogs"])) {
                this.userLogs = [] as any;
                for (let item of _data["userLogs"])
                    this.userLogs!.push(UserAuditLogDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserAuditLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuditLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userLogs)) {
            data["userLogs"] = [];
            for (let item of this.userLogs)
                data["userLogs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserAuditLogViewModel {
    userLogs?: UserAuditLogDTO[] | undefined;
}

export class UserAuditLogDTO implements IUserAuditLogDTO {
    action?: string | undefined;
    fieldChanged?: string | undefined;
    beforeValue?: string | undefined;
    afterValue?: string | undefined;
    createdBy?: string | undefined;
    created?: Date | undefined;

    constructor(data?: IUserAuditLogDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.fieldChanged = _data["fieldChanged"];
            this.beforeValue = _data["beforeValue"];
            this.afterValue = _data["afterValue"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserAuditLogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuditLogDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["fieldChanged"] = this.fieldChanged;
        data["beforeValue"] = this.beforeValue;
        data["afterValue"] = this.afterValue;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserAuditLogDTO {
    action?: string | undefined;
    fieldChanged?: string | undefined;
    beforeValue?: string | undefined;
    afterValue?: string | undefined;
    createdBy?: string | undefined;
    created?: Date | undefined;
}

export class UsersViewModel implements IUsersViewModel {
    users?: UserDTO[] | undefined;

    constructor(data?: IUsersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UsersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UsersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUsersViewModel {
    users?: UserDTO[] | undefined;
}

export class SearchUserQueryModel implements ISearchUserQueryModel {
    users?: UserSearchDTO[] | undefined;

    constructor(data?: ISearchUserQueryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserSearchDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchUserQueryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchUserQueryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchUserQueryModel {
    users?: UserSearchDTO[] | undefined;
}

export class UserSearchDTO implements IUserSearchDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    organisationIdentifier?: string | undefined;

    constructor(data?: IUserSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.organisationIdentifier = _data["organisationIdentifier"];
        }
    }

    static fromJS(data: any): UserSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["organisationIdentifier"] = this.organisationIdentifier;
        return data;
    }
}

export interface IUserSearchDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    organisationIdentifier?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}